import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'
import AiFrequencyPage from './AiFrequencyPage'
import AiImpactPage from './AiImpactPage'
import AiReactionPage from './AiReactionPage'
import AiToolsPage from './AiToolsPage'
import AiWitnessPage from './AiWitnessPage'
import AnalyzingPage from './AnalyzingPage'
import CareerPriorityPage from './CareerPriorityPage'
import CompanySizePage from './CompanySizePage'
import ConcernFeedbackPage from './ConcernFeedbackPage'
import DailyTasksPage from './DailyTasksPage'
import DataFrequencyPage from './DataFrequencyPage'
import DecisionMakingPage from './DecisionMakingPage'
import EducationPage from './EducationPage'
import ExperiencePage from './ExperiencePage'
import FieldPage from './FieldPage'
import FinalWordPage from './FinalWordPage'
import IndustryPage from './IndustryPage'
import JobSecurityPage from './JobSecurityPage'
import LevelPage from './LevelPage'
import LocationPage from './LocationPage'
import ProudSkillPage from './ProudSkillPage'
import RepetitivenessPage from './RepetitivenessPage'
import RolePage from './RolePage'
import SalaryRangePage from './SalaryRangePage'
import SplashPage from './SplashPage'
import SummaryPage from './SummaryPage'
import WritingFrequencyPage from './WritingFrequencyPage'

const onboardingRoutes = [
  {
    path: '',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        path: 'welcome',
        element: <SplashPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'location',
        element: <LocationPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'ai-reaction',
        element: <AiReactionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'career-priority',
        element: <CareerPriorityPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'field',
        element: <FieldPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'role',
        element: <RolePage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'experience',
        element: <ExperiencePage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'level',
        element: <LevelPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'proud-skill',
        element: <ProudSkillPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'company-size',
        element: <CompanySizePage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'industry',
        element: <IndustryPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'ai-impact',
        element: <AiImpactPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'daily-tasks',
        element: <DailyTasksPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'repetitiveness',
        element: <RepetitivenessPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'ai-tools',
        element: <AiToolsPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'ai-frequency',
        element: <AiFrequencyPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'ai-witness',
        element: <AiWitnessPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'concern-feedback',
        element: <ConcernFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'data-frequency',
        element: <DataFrequencyPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'writing-frequency',
        element: <WritingFrequencyPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'decision-making',
        element: <DecisionMakingPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'job-security',
        element: <JobSecurityPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'education',
        element: <EducationPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'salary-range',
        element: <SalaryRangePage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'summary',
        element: <SummaryPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'final-word',
        element: <FinalWordPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'analyzing',
        element: <AnalyzingPage />,
        action: navigateToNextOnboardingPageAction,
      },
    ],
  },
]

export default onboardingRoutes
